import { call, takeLatest } from "redux-saga/effects";

import {
  ALERT_CREATE,
  ALERT_DELETE,
  ALERT_EDIT,
  ALERT_STATUS,
  ALERT_TABLE,
  ALERT_VIEW,
} from "../types";
import { alertCreateApi, alertDeleteApi, alertEditApi, alertStatusApi, alertTableApi, alertViewApi } from "../apis/alert-api";

export function* alertCreateWorker(action) {
  try {
    const res = yield call(alertCreateApi, action.data);
    
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* alertTableWorker(action) {
  try {
    const res = yield call(alertTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* alertViewWorker(action) {
  try {
    const res = yield call(alertViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* alertDeleteWorker(action) {
  try {
    const res = yield call(alertDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* alertEditWorker(action) {
  try {
    const res = yield call(alertEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* alertStatusWorker(action) {
  try {
    const res = yield call(alertStatusApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* alertCreateWatcher() {
  yield takeLatest(ALERT_CREATE, alertCreateWorker);
}
export function* alertTableWatcher() {
  yield takeLatest(ALERT_TABLE, alertTableWorker);
}
export function* alertViewWatcher() {
  yield takeLatest(ALERT_VIEW, alertViewWorker);
}
export function* alertDeleteWatcher() {
  yield takeLatest(ALERT_DELETE, alertDeleteWorker);
}
export function* alertEditWatcher() {
  yield takeLatest(ALERT_EDIT, alertEditWorker);
}
export function* alertStatusWatcher() {
  yield takeLatest(ALERT_STATUS, alertStatusWorker);
}


